module.exports = __webpack_public_path__ + "7f18ec9434238be58d7300e325e90bbd.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/BZ.svg
// module id = tXnu
// module chunks = 0